import type { MarketDataSnapshot, MarketDataSnapshotLevel } from '@talos/kyoko';

interface GetMarketDataLevelPricesParams {
  snapshot: MarketDataSnapshot | null | undefined;
  index: number;
  isPricingModeBPS?: boolean;
}

interface MarketDataLevelPrices {
  bidPrice: string | undefined;
  offerPrice: string | undefined;
}

function getLevelPrice(level: MarketDataSnapshotLevel | undefined, isPricingModeBPS?: boolean) {
  if (!level) {
    return undefined;
  }
  return isPricingModeBPS ? level.BPS : level.Price;
}

/**
 * Returns bid and offer prices from a MarketDataSnapshot at a given index, based on current pricing mode.
 */
export function getMarketDataLevelPrices({
  snapshot,
  index,
  isPricingModeBPS,
}: GetMarketDataLevelPricesParams): MarketDataLevelPrices {
  if (!snapshot) {
    return { bidPrice: undefined, offerPrice: undefined };
  }

  return {
    bidPrice: getLevelPrice(snapshot.Bids?.[index], isPricingModeBPS),
    offerPrice: getLevelPrice(snapshot.Offers?.[index], isPricingModeBPS),
  };
}
